<template>
  <v-footer v-if="footerBlock || !$auth.loggedIn" class="px-2 main-foot">
    <v-container :class="$breakpoint.xsOnly ? 'mb-8' : ''">
      <v-row>
        <v-col cols="12" md="3" sm="12">
          <v-img
            :src="require('@/assets/logos/fairplay-website-logo.png')"
            :lazy-src="require('@/assets/logos/fairplay-website-logo.png')"
            :width="$breakpoint.xsOnly ? 80 : 130"
            class="fairplay_logo"
            contain
            :aspect-ratio="$vuetify.breakpoint.smAndDown ? 1.5 : 1.67"
            alt="Fairplay Logo"
          ></v-img>
          <div class="caption">
            <span>
              {{ $t('footer.copyright') }}
            </span>
          </div>
          <v-col
            v-if="
              getWhatsappData &&
              getWhatsappData.isWhatsAppNo &&
              getWhatsappData.number
            "
            class="pl-0"
            cols="6"
            md="12"
            sm="3"
          >
            <v-divider></v-divider>
          </v-col>
          <div
            v-if="
              getWhatsappData &&
              getWhatsappData.isWhatsAppNo &&
              getWhatsappData.number &&
              getWhatsappData.whatsAppLink
            "
          >
            {{ $t('footer.contact_us') }}:
            <a
              :href="getWhatsappData.whatsAppLink"
              target="_blank"
              rel="noreferrer noopener"
              class="text-decoration-none"
              :class="$vuetify.theme.dark ? 'white--text' : 'black--text'"
              >{{ getWhatsappData.number }}
            </a>
          </div>
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <v-divider></v-divider>
        </v-col>
        <v-col
          cols="12"
          :sm="9"
          :md="10"
          class="text-sm-left text-md-left text-left"
        >
          <div class="caption">{{ $t('footer.disclaimer') }} :</div>
          <div class="caption">
            {{ $t('footer.disclaimer_text') }}
          </div>
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="12"
          class="text-left caption my-footer hidden-sm-and-down"
        >
          &copy; {{ new Date().getFullYear() }} {{ $t('footer.reserved') }}
        </v-col>
        <v-col cols="12" class="text-left caption my-footer hidden-md-and-up">
          &copy; {{ new Date().getFullYear() }} {{ $t('footer.reserved') }}
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
import { mapState } from 'vuex'
export default {
  components: {},
  data() {
    return {
      CDN_IMG_URL: process.env.CDN_IMG_URL,
      domain: process.env.BASE_URL,
      path: '',
      footerBlock: false,
      showDisclaimer: false,
      listOne: [
        {
          name: 'footer.card_game',
          link: '/live-card-games'
        },

        {
          name: 'footer.cricket_betting',
          link: '/sports/online-cricket-betting'
        },
        {
          name: 'footer.ipl_betting',
          link: '/sports/online-cricket-betting/ipl'
        },
        {
          name: 'footer.football_betting',
          link: '/sports/online-football-betting'
        },
        {
          name: 'footer.tennis_betting',
          link: '/sports/online-tennis-betting'
        },
        {
          name: 'footer.live_casino_betting',
          link: '/live-casino'
        }
      ],
      listTwo: [
        {
          name: 'footer.about_us',
          link: '/about-us'
        },
        {
          name: 'footer.rules',
          link: '/rules-regulations'
        },
        {
          name: 'footer.privacy_policy',
          link: '/privacy-policy'
        },
        {
          name: 'footer.sitemap',
          link: '/sitemap'
        },
        {
          name: 'footer.responsible_gambling',
          link: '/responsible-gambling'
        },
        {
          name: 'footer.terms_condition',
          link: '/termsandconditions'
        },
        {
          name: 'AML Policies',
          link: 'https://bestfairplay.com/aml-policies'
        }
      ],
      listThree: [
        {
          name: 'footer.fairplay_news',
          link: 'https://www.fairplaynews.club/'
        },
        {
          name: 'footer.premium_sportbook_betting',
          link: '/premium-sportsbook'
        }
      ]
    }
  },
  computed: {
    ...mapState({
      getWhatsappData: (state) => state.user.whatsappData
    })
  },

  watch: {
    $route(to, from) {
      this.path = this.$route.path
      this.abc(this.path)
    }
  },
  async created() {
    await this.$store.dispatch('user/getconfigs')
  },

  mounted() {
    this.abc(this.$nuxt.context.from.path)
  },
  methods: {
    abc(path) {
      if (path === '/') {
        this.footerBlock = true
      } else {
        this.footerBlock = false
      }
    }
  }
}
</script>
<style lang="scss">
.main-foot {
  // margin-top: 60px;
  padding-bottom: 2rem;
  .gaming-image {
    display: grid;
    place-content: center;
  }
  .androip-apk:hover {
    filter: brightness(170%);
    cursor: pointer;
  }
  .col-md-2 ul li a:hover {
    color: $primary !important;
  }
  .col-md-1 ul li a:hover {
    color: $primary !important;
  }
}
.list-style-none {
  list-style: none;
}
.footer-icon {
  .v-btn--icon.v-size--default {
    width: 23px !important;
    height: 23px !important;
  }
  .v-btn__content {
    justify-content: start !important;
  }
}
</style>
